<template>
  <div
    class="truncate pl-1 pb-1"
    style="width: 150px">
    <span class="font-bold text-gray-600">
      ユーザ選択数 {{ selectedUsers.length }}/{{ pagination.data.length }}
    </span>
  </div>
  <div class="shadow-lg bg-white mr-1 rounded-b-lg rounded-t">
    <div v-if="pagination.data.length">
      <data-table
        :headers="headers"
        :items="pagination.data"
        drag-disabled
        sort-disabled>
        <template #th-checkbox>
          <input
            v-model="selectedCurrentPageUsers"
            type="checkbox"
            class="bg-gray-50 border-gray-300 focus:ring-3 focus:ring-blue-300 h-4 w-4 rounded focus:outline-none" />
        </template>
        <template #check_box="{ item }">
          <input
            v-model="selectedUserIds"
            :value="item.id"
            type="checkbox"
            class="bg-gray-50 border-gray-300 focus:ring-3 focus:ring-blue-300 h-4 w-4 rounded focus:outline-none" />
        </template>
        <template #name="{ item }">
          <div
            class="truncate"
            style="width: 180px">
            {{ item.name }}
          </div>
        </template>
        <template #email="{ item }">
          <div
            class="truncate"
            style="width: 200px">
            {{ item.email }}
          </div>
        </template>
        <template #school="{ item }">
          <div
            class="truncate"
            style="width: 150px">
            {{ item.school || '-' }}
          </div>
        </template>
        <template #isPurchase="{ item }">
          <span :class="item.isPurchase ? 'text-green-600 font-bold' : 'text-gray-400'">
            {{ item.isPurchase ? '付与済み' : '未付与' }}
          </span>
        </template>
      </data-table>
      <div class="mb-5 pb-5">
        <div class="mt-4">
          <pagination
            :paginate="pagination"
            @page-previous="onPaginationChanged"
            @page-next="onPaginationChanged"
            @page-click="onPaginationChanged" />
        </div>
      </div>
    </div>
    <div
      v-else
      class="py-4">
      <div
        class="mx-auto w-11/12 bg-red-100 border border-red-400 text-red-500 px-4 py-3 rounded relative text-center"
        role="alert">
        <span class="block sm:inline font-bold">ユーザが見つかりませんでした。</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { Inertia } from '@inertiajs/inertia'
import { ref, computed, watch } from 'vue'
import DataTable from '@/Common/DataTable'
import Pagination from '../../../Common/Pagination'

const props = defineProps({
  pagination: {
    type: Object,
    required: true,
  },
  examination: {
    type: Object,
    required: true,
  },
  limit: {
    type: String,
    default: '15',
  },
  userId: {
    type: String,
    default: '',
  },
  name: {
    type: String,
    default: '',
  },
  email: {
    type: String,
    default: '',
  },
  school: {
    type: String,
    default: '',
  },
  linkedStatus: {
    type: String,
    default: '',
  },
  isPurchase: {
    type: Boolean,
    default: false,
  },
  resetSelection: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['select-users'])

// ヘッダー情報
const headers = {
  check_box: '',
  id: 'ユーザID',
  name: '名前',
  email: 'メールアドレス',
  school: '所属学校',
  isPurchase: '付与状態',
}

// 選択されたユーザの情報
const selectedUsers = ref([])
// v-model用のIDリスト
const selectedUserIds = ref([])

// IDリストの変更を監視して、selectedUsersを更新
watch(selectedUserIds, (newIds) => {
  selectedUsers.value = newIds.map(id => {
    const user = props.pagination.data.find(item => item.id === id)
    return user ? {
      id: user.id,
      name: user.name,
      email: user.email,
      school: user.school || '-',
    } : null
  }).filter(Boolean)

  emit('select-users', selectedUsers.value)
}, { deep: true })

// チェックボックスの一括選択・削除
const selectedCurrentPageUsers = computed({
  get: () =>
    // 現在のページの全ユーザが選択されているかチェック
    props.pagination.data.length > 0
          && props.pagination.data.every(item => selectedUserIds.value.includes(item.id)),
  set: (bool) => {
    if (bool) {
      // 現在のページの全ユーザIDを追加（重複を避ける）
      const currentPageIds = props.pagination.data.map(item => item.id)
      const newIds = [...new Set([...selectedUserIds.value, ...currentPageIds])]
      selectedUserIds.value = newIds
    } else {
      // 現在のページのユーザIDを削除
      const currentPageIds = props.pagination.data.map(item => item.id)
      selectedUserIds.value = selectedUserIds.value.filter(id => !currentPageIds.includes(id))
    }
  },
})

// 選択状態のリセットを監視
watch(() => props.resetSelection, (newValue) => {
  if (newValue) {
    selectedUserIds.value = []
    selectedUsers.value = []
    emit('select-users', [])
  }
})

const onPaginationChanged = (page) => {
  Inertia.get(route('examinations.showAddExamination', { examination: props.examination.id }), {
    page,
    limit: props.limit,
    userId: props.userId,
    name: props.name,
    email: props.email,
    school: props.school,
    linkedStatus: props.linkedStatus,
  })
}
</script>
